import { useParams } from "react-router-dom";
import { ClientBookingConfirmation } from "@/components/pages/Client";
import { ClientScopeProvider } from "@/components/pages/Client/settings/ClientScopeContext";
import { useGetClientProfileQuery } from "@/redux/apis/clientProfile/clientProfileApi";

/**
 * Operator-scoped booking confirmation (DEV-462). Wraps the existing confirmation page in
 * ClientScopeProvider so its CTAs stay scoped to the client (book another) and return to the
 * operator's Bookings list rather than the client-portal home. Passes the client's name so the
 * success heading reads "{client}'s trip is confirmed…" (deduped with ManageClient's profile query).
 */
export const OperatorClientBookingConfirmation = () => {
  const { clientId = "" } = useParams<{ clientId: string }>();
  const { data: profile } = useGetClientProfileQuery({ accountId: clientId }, { skip: !clientId });
  const clientName = profile ? `${profile.personal.first_name} ${profile.personal.last_name}`.trim() : undefined;

  return (
    <ClientScopeProvider accountId={clientId} clientName={clientName}>
      <ClientBookingConfirmation />
    </ClientScopeProvider>
  );
};
